import UnifiedSkybus from "@skydio/skybus/src/unified";
import SkybusProviderLive from "@skydio/skybus/src/provider/live";
import SkybusLive from "@skydio/skybus/src/live";
import { tunnel_channel_t } from "@skydio/lcm/types/skybus_tunnel/tunnel_channel_t";
import { LivekitTransportArgs, RemoteDeviceType } from "@skydio/skybus/src/transport/types";
import LivekitTransportLayer from "@skydio/skybus/src/transport/livekit/livekit_transport_layer";
import { Connector } from "@skydio/skybus/src/transport/base";
import { broadcast_channels_p } from "@skydio/lcm/types/ptree/broadcast_channels_p";
import { broadcast_channel_t } from "@skydio/lcm/types/iot_api/broadcast_channel_t";

const createSkybusStack = <T extends Connector>(
  connector: T,
  tunnelChannels: tunnel_channel_t[],
  broadcastChannels: broadcast_channel_t[]
) => {
  const skybusLive = new SkybusLive(connector, tunnelChannels, broadcastChannels);
  const provider = new SkybusProviderLive(skybusLive);
  const skybus = new UnifiedSkybus(provider);
  return { connector, skybusLive, skybus };
};

export const setupLivekitSkybus = (
  transportArgs: LivekitTransportArgs,
  tunnelChannels?: tunnel_channel_t[],
  dockTunnelChannels?: tunnel_channel_t[],
  broadcastChannels?: broadcast_channels_p
) => {
  const transportLayer = new LivekitTransportLayer(transportArgs);
  const vehicleConnector = transportLayer.createConnector(RemoteDeviceType.VEHICLE);
  const vehicleStack = createSkybusStack(
    vehicleConnector,
    tunnelChannels ?? [],
    broadcastChannels?.vehicle ?? []
  );
  const dockConnector = transportLayer.createConnector(RemoteDeviceType.DOCK);
  const dockStack = createSkybusStack(
    dockConnector,
    dockTunnelChannels ?? [],
    broadcastChannels?.dock ?? []
  );
  return { transportLayer, devices: [vehicleStack, dockStack] };
};
